import { render, staticRenderFns } from "./ContractorsList.vue?vue&type=template&id=452f133c&scoped=true&"
import script from "./ContractorsList.vue?vue&type=script&lang=js&"
export * from "./ContractorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f133c",
  null
  
)

export default component.exports